import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {api} from "../../maps/data.js";
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";
import PageTitle from "../../components/PageTitle";
import Field from "../../components/storeShelves/Field";
import AlertSettingsDisplay from "../../components/storeShelves/AlertSettingsDisplay";
import useZibi from "../../zibi/UseZibi";
import {Drawer} from "@mui/material";
import AlertSettingsEdit from "../../components/storeShelves/AlertSettingsEdit";
import AlertsDrawerDisplay from "../../components/storeShelves/AlertsDrawerDisplay";

const WrapperStyled = styled.div`
    display: grid;
`;

const CommonActionsStyled = styled.div`
    display: grid;
    grid-gap: 5px;
`;

const SensorsAreaStyled = styled.div`
    background: rgb(231, 235, 240);
    width: 100%;
    display: grid;
    grid-gap: 15px;
    padding: 10px;
    border-radius: 8px;
`;


const TitleWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
`;


const StoreShelves = () => {
    const [fieldsData, s_fieldsData] = useState([]);
    const [currentSite, set_currentSite] = useZibi('currentSite');
    const [showDrawerData, s_showDrawerData] = useState(false);
    const [showDrawerAlerts, s_showDrawerAlerts] = useState(false);

    useEffect(() => {
        getFieldAndData();
        getSite();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            getFieldAndData();
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    const getFieldAndData = async () => {
        console.log('getFieldAndData');
        api({
            type: "getFields"
        }).then(data => {
            s_fieldsData(data);
        }).catch(e => {
            console.error(e);
        });
    };
    const getSite = async (force = false) => {
        if (!currentSite || force) {
            const res = await api({
                type: 'getSites',
                data: {}
            });
            set_currentSite(res?.[0]);
        }
    };

    return (
        <div style={{height: '100%', overflowY: 'scroll', padding: 20}}>
            <TitleWrapperStyled>
                <PageTitle>
                    <div style={{position: 'relative'}}>
                        <Icn>sensor</Icn> <Tx>menu.storeShelves</Tx>
                    </div>
                </PageTitle>
                <AlertSettingsDisplay
                    item={currentSite}
                    type={'Site Settings'}
                    entType={'site'}
                    openSettingsHandle={() => {
                        s_showDrawerData({data: currentSite, type: 'site'});
                    }}
                />
            </TitleWrapperStyled>
            <CommonActionsStyled>

            </CommonActionsStyled>
            <WrapperStyled>
                <SensorsAreaStyled>
                    {
                        fieldsData.map((field) => {
                            return (
                                <Field
                                    openSettingsHandle={(data) => {
                                        s_showDrawerData(data);
                                    }}
                                    openAlerts={() => s_showDrawerAlerts(field)}
                                    key={field._id}
                                    data={field}
                                    site={currentSite}
                                />
                            );
                        })
                    }
                </SensorsAreaStyled>
            </WrapperStyled>
            <Drawer
                variant="temporary"
                open={!!showDrawerData}
                onClose={() => {
                    s_showDrawerData(null);
                }}
                anchor={'right'}
            >
                <AlertSettingsEdit
                    data={showDrawerData?.data}
                    type={showDrawerData?.type}
                    field={showDrawerData?.field}
                    site={currentSite}
                    onClose={() => {
                        switch (showDrawerData?.type) {
                            case "site":
                                getSite(true);
                                break;
                            case "sensor":
                            case "field":
                                getFieldAndData();
                                break;
                        }
                        s_showDrawerData(null);
                    }}
                />
            </Drawer>
        </div>
    );
};

export default StoreShelves;